import React, { useState, useEffect } from 'react';
import '../styles/AboutPage.scss';

function AboutPage() {
    const [data, setData] = useState([]);

    return (
        <div className="web-body">
            <h1>About Us</h1>
        </div>
    );

}

export default AboutPage;
